/* eslint-disable @typescript-eslint/no-unused-vars */
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  setEmployeeDetails,
  setFiles,
  setFormDetails
} from "../../../../redux/features/shared/sharedSlice";

function EmployeeDetailsModal() {
  const dispatch: any = useDispatch();
  const sharedActions: any = useSelector((state: any) => state.sharedActions);

  const closeModal = () => {
    dispatch(setEmployeeDetails(false));
    dispatch(setFormDetails({}));
    dispatch(setFiles([]));
  };

  return (
    <>
      <Modal
        className="wrapmodal"
        backdrop="static"
        size="lg"
        show={sharedActions.employeeShowDetailsModal}
        onHide={closeModal}
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Employee Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="wrapmodalInner">
            <div className="row mb-4">
              <div className="col-md-12">
                <div className="half50">
                  <p>
                    <strong> Company:</strong>{" "}
                    {sharedActions.formDetails?.companyName || "N/A"}
                  </p>
                  <p>
                    <strong> First Name:</strong>{" "}
                    {sharedActions.formDetails?.firstName || "N/A"}
                  </p>
                  <p>
                    <strong> Last Name:</strong>{" "}
                    { sharedActions.formDetails?.lastName || "N/A"}
                  </p>
                  <p>
                    <strong> Status:</strong>{" "}
                    { sharedActions.formDetails?.status || "N/A"}
                  </p>
                  <p>
                    <strong> Email Address:</strong>{" "}
                    {sharedActions.formDetails?.email || "N/A"}
                  </p>
                  <p>
                    <strong> Package Name:</strong>{" "}
                    {sharedActions.formDetails?.packageName || "N/A"}
                  </p>
                  <p>
                    <strong> Subscription Payment History:</strong>{" "}
                    { sharedActions.formDetails?.subscription?.status || "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export { EmployeeDetailsModal };
